import { useNavigate } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/anime';

export default function Footer() {
  const navigate = useNavigate();

  const handleNav = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-950 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-50 whitespace-nowrap">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-foreground-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/" onClick={(e) => { e.preventDefault(); handleNav('/'); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              </li>
              <li>
                <a href="/about" onClick={(e) => { e.preventDefault(); handleNav('/about'); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-foreground-50 mb-4">动漫分类</h3>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={`/category/${cat.slug}`}
                    onClick={(e) => { e.preventDefault(); handleNav(`/category/${cat.slug}`); }}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-foreground-50 mb-4">联系我们</h3>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@tiantiananime.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </span>
                400-888-6666
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="/" onClick={(e) => { e.preventDefault(); handleNav('/'); }} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="/about" onClick={(e) => { e.preventDefault(); handleNav('/about'); }} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}